import { WaitingForCall, Validation, ExitModule, AllBenefits } from '@modals';
import React from 'react';

export const ModalsPlaceholder: React.FC = () => {
	return (
		<>
			<WaitingForCall />
			<Validation />
			<ExitModule />
			<AllBenefits />
		</>
	);
};
